<template>
    <el-dialog v-model="dialogVisible" :visible.sync="dialogVisible" title="Menu details" width="500">
        <div class="erm_standard_details_container">

            <div class="erm_details_image">
                <img style="border-radius: 8px;" :src="item?.image"
                    alt="Logo" class="erm_logo" />
            </div>
            <div class="erm_details_text">
                <div class="erm_details_menu_name">
                    <h2 class="erm_menu_title">{{ item?.name }}</h2>
                </div>
                <div class="erm_menu_details_price">
                    <p>{{ item?.price }} BDT</p>
                </div>
            </div>
            <div class="erm_details_portion_sizes">
                <a class="portion_item" href="#">Small</a>
                <a class="portion_item" href="#">Medium </a>
                <a class="portion_item" href="#">Large </a>

            </div>
            <div class="erm_details_menu_description">
                <h1 class="erm_dec_title">Description</h1>
                <p class="erm_dec">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore
                    et
                    dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip
                    ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu
                    fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                </p>
            </div>

            <div class="erm_details_addons">
                <h1 class="erm_addon_title">Choice of Add On</h1>

                <div class="erm_addon_item">
                    <div class="addon_name">Extra Sauce <span>+$20.00</span></div>
                    <div class="erm_addon_checkbox">
                        <input type="checkbox">
                    </div>

                </div>
                <div class="erm_addon_item">
                    <div class="addon_name">Extra Sauce <span>+$20.00</span></div>
                    <div class="erm_addon_checkbox">
                        <input type="checkbox">
                    </div>

                </div>

            </div>

            <!-- <div class="erm_menu_details_add_to_cart">
                <button class="erm_add_to_cart_button">Add to Cart</button>
            </div> -->
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">Cancel</el-button>
                <el-button type="primary" @click="dialogVisible = false">
                    Confirm
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>


<script>
export default {
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            dialogVisible: false,
        }
    },
    methods : {
        openModel() {
            this.dialogVisible = true;
        },
        handleClose(done) {
           this.dialogVisible = false;
        },
    }
}
</script>
